import { useState } from "react";
import { useTranslation } from "react-i18next";
import { request } from "../api/client";
import { useSession } from "./context";
import { sessionExpiredEvent } from "./session";
import { secondaryAction } from "./styles";

export function AccountPanel() {
 const session = useSession();
 const { t } = useTranslation();
 const [busy, setBusy] = useState(false);
 const [error, setError] = useState(false);
 if (!session) return null;
 async function logout() {
  setBusy(true); setError(false);
  try {
   const result = await request<{ logoutUrl: string }>("/auth/logout", { method: "POST" });
   window.dispatchEvent(new Event(sessionExpiredEvent));
   window.location.assign(result.logoutUrl);
  } catch { setError(true); setBusy(false); }
 }
 return <section className="rounded-xl border border-line bg-surface-raised/55 p-3" aria-label={t("auth.account")}>
  <p className="truncate text-sm font-semibold">{session.user.name}</p>
  <p className="mt-1 text-xs text-muted">{t(session.mode === "oidc" ? "auth.signedIn" : "auth.development")}</p>
  {session.mode === "oidc" ? <button className={`${secondaryAction} mt-3 w-full`} disabled={busy} onClick={() => void logout()}>{t("auth.logout")}</button> : null}
  {error ? <p role="alert" className="mt-2 text-sm">{t("auth.logoutFailed")}</p> : null}
 </section>;
}
